import { render, staticRenderFns } from "./EditClientePolizaInfo.vue?vue&type=template&id=13ca6227&scoped=true&"
import script from "./EditClientePolizaInfo.vue?vue&type=script&lang=js&"
export * from "./EditClientePolizaInfo.vue?vue&type=script&lang=js&"
import style0 from "./EditClientePolizaInfo.vue?vue&type=style&index=0&id=13ca6227&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ca6227",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VCol,VRow,VTextField})
